import { render } from "./SetPartnerPassword.vue?vue&type=template&id=68b6a185"
import script from "./SetPartnerPassword.vue?vue&type=script&lang=js"
export * from "./SetPartnerPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__